import { useSelector } from "react-redux";
import { IAppState } from "../store/Store";

export const useStoreState = () => {
  return useSelector<IAppState, IAppState>((state: IAppState) => state);
};
